// Import dependencies
import { builderFetch } from '@builder/core/utilities';

/**
 * Updates all the [action] filters.
 * This one, unlike the other update functions, updates all filters at the same time.
 *
 * @param {String} filters The [action] filters, in a JSON string
 * @return {Promise} The fetch promise
 */
const updateFilters = ( filters = '' ) => {
	// Event name
	const eventName = 'uap/builder/core/item/filter/update-filters';

	// Save the recipe title
	return builderFetch( {
		eventName: eventName,
		endpoint: `actions_conditions_update`,
		method: 'POST',
		data: {
			// eslint-disable-next-line camelcase
			recipe_id: UncannyAutomator._recipe.recipe_id,
			// eslint-disable-next-line camelcase
			actions_conditions: filters,
		},
		snackbar: {
			loading: _uo.utility.escHTML( wp.i18n.__( 'Updating filters', 'uncanny-automator' ) ),
			success: _uo.utility.escHTML( wp.i18n.__( 'Filters updated successfully', 'uncanny-automator' ) ),
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( eventName, {
				detail: {
					actionsConditions: filters
				}
			} ) );
		}

		return response;
	} );
}

export default updateFilters;
